import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
    const userName = localStorage.getItem('user_name')
    const location = useLocation()

    if (typeof window === 'undefined') {
        return null
    }

    const isAuthorizePage = location.pathname === '/authorize'
    const params = new URLSearchParams(location.search)
    const redirectParam = params.get('redirect')

    // ✅ If user is logged in and hits /authorize with redirect, redirect them directly
    if (userName && isAuthorizePage && redirectParam) {
        window.location.href = redirectParam
        return null
    }

    // ✅ For other cases, continue existing behavior
    return userName ? <Navigate to="/client" /> : <Component {...rest} />
}

export default PublicRoute
